export default "__VITE_ASSET__DiXnqmo6__"